import { createValidationSchema } from "../../../../utils";

const commonValidationInputs = [
  {
    key: "firstName",
    type: "text",
  },
  {
    key: "lastName",
    type: "text",
  },
  {
    key: "email",
    type: "email",
  },
];

export const commonValidationInput = createValidationSchema(commonValidationInputs);

export const adminModeValidationInput = createValidationSchema([
  ...commonValidationInputs,
  {
    key: "orgId",
    type: "number",
  },
  {
    key: "groupId",
    type: "number",
  },
]);

export const orgModeValidationInput = createValidationSchema([
  ...commonValidationInputs,
  {
    key: "groupId",
    type: "number",
  },
]);
